<template>
	<div class="filter-panel" :style="{ paddingBottom: safeAreaInsetBottom + 'px' }">
		<div class="panel-header">
			<div>筛选</div>

			<div class="back-btn" @click="$emit('close')">
				<nio-icon name="icon_close_2xs" :size="16" />
			</div>
		</div>

		<div class="panel-config-list">
			<div class="vertical-indicator">
				<div
					v-for="section in sections"
					class="section-item"
					:class="{ active: curSection === section.id }"
					v-sd-clk:FilterItemClick="{
						page: '二手车商城',
						page_source: pageSource,
						tab_name: section.label,
						requirement_id: 2015,
						track_sign: 'aMall.b72.d2244.click.FilterItemClick'
					}"
					@click="gotoSection(section.id)"
				>
					{{ section.label }}
				</div>
			</div>
			<div class="filter-content" ref="filterContent">
				<div class="filter-config" id="config-businessType">
					<div class="config-title">
						<span>交易类型</span>
						<span
							class="reset-section"
							@click="selection.sellers = []"
							:class="{ active: !!selection.sellers.length }"
						>
							重置
						</span>
					</div>
					<div class="config-item-list">
						<div
							v-for="(seller, index) in allSeller"
							:key="index"
							class="config-item"
							:class="{
								selected: selection.sellers.some(one => one === seller.value)
							}"
							@click="pickConfigItem('sellers', seller.value)"
						>
							{{ seller.label }}
						</div>
					</div>
				</div>

				<div class="filter-config" id="config-originCity">
					<template v-if="onlyOfficial">
						<div class="config-title">
							<span>官方二手车车源地</span>
							<span
								class="reset-section"
								@click="selection.originCities = []"
								:class="{ active: !!selection.originCities.length }"
							>
								重置
							</span>
						</div>

						<div class="config-item-list">
							<div
								v-for="city in officialCenters"
								class="config-item"
								:class="{ selected: selection.originCities.some(one => one.code === city.code) }"
								@click="pickConfigItem('originCities', city)"
							>
								{{ city.name }}
							</div>
						</div>
					</template>
					<template v-else>
						<div class="config-title">
							<span>车源地</span>
							<span
								class="reset-section"
								@click="selection.originCities = []"
								:class="{ active: !!selection.originCities.length }"
							>
								重置
							</span>
						</div>

						<div class="config-item-list">
							<div v-for="(city, idx) in selection.originCities" class="config-item tag selected">
								<span>{{ city.name }}</span>
								<nio-icon
									@click="selection.originCities.splice(idx, 1)"
									name="icon_close_2xs"
									:size="16"
								/>
							</div>

							<div class="config-item" @click="isShowAddressList = true">
								<nio-icon name="icon_add_2xs" :size="16" style="margin-right: 8px" />
								添加
							</div>
						</div>
					</template>
				</div>

				<div class="filter-config" id="config-carModel">
					<div class="config-title">
						<span>车型</span>
						<span
							class="reset-section"
							@click="selection.carTypes = []"
							:class="{ active: !!selection.carTypes.length }"
						>
							重置
						</span>
					</div>
					<div class="config-item-list">
						<div
							v-for="carType in allCarTypes"
							:key="carType"
							class="config-item large"
							:class="{ selected: selection.carTypes.indexOf(carType) >= 0 }"
							@click="pickConfigItem('carTypes', carType)"
						>
							<nio-icon v-if="carType.toLowerCase() === 'et9'" class="model-name" src="https://cdn-fx.nio.com/fx/second-hand-app-pkg/__cdn__/Uy25CDNYH9XggXIFf_rC6/icon_nio_et9.png" />
							<nio-icon v-else class="model-name" :name="'icon_nio_' + carType.toLowerCase()" />
							<img class="model-pic" :src="modelImagePics[carType]" />
						</div>
					</div>
				</div>

				<div class="filter-config">
					<div class="config-title">
						<span>购买方式</span>
						<span
							class="reset-section"
							@click="selection.baasTypes = []"
							:class="{ active: selection.baasTypes.length }"
						>
							重置
						</span>
					</div>
					<div class="config-item-list">
						<div
							v-for="(baasType, index) in allBaasTypes"
							:key="index"
							class="config-item"
							:class="{
								selected: selection.baasTypes.some(one => one === baasType.value)
							}"
							@click="pickConfigItem('baasTypes', baasType.value)"
						>
							{{ baasType.label }}
						</div>
					</div>
				</div>

				<div class="filter-config">
					<div class="config-title">
						<span>电池容量</span>
						<span
							class="reset-section"
							@click="selection.battery = []"
							:class="{ active: selection.battery.length }"
						>
							重置
						</span>
					</div>
					<div class="config-item-list">
						<div
							v-for="(battery, index) in allBatteries"
							:key="index"
							class="config-item"
							:class="{
								selected: selection.battery.some(one => one === battery.value)
							}"
							@click="pickConfigItem('battery', battery.value)"
						>
							{{ battery.label }}
						</div>
					</div>
				</div>

				<div class="filter-config" id="config-price">
					<div class="config-title">
						<span>
							价格
							<span class="config-subtitle">(万)</span>
						</span>
						<span
							class="reset-section"
							@click="selection.priceRanges = []"
							:class="{ active: !!selection.priceRanges.length }"
						>
							重置
						</span>
					</div>
					<ChartRanger type="price" :range.sync="selection.priceRanges[0]" />
				</div>

				<div class="filter-config" id="config-age">
					<div class="config-title">
						<span>
							车龄
							<span class="config-subtitle">(年)</span>
						</span>
						<span
							class="reset-section"
							@click="selection.ages = []"
							:class="{ active: !!selection.ages.length }"
						>
							重置
						</span>
					</div>
					<ChartRanger type="age" :range.sync="selection.ages[0]" />
				</div>

				<div class="filter-config" id="config-mileage">
					<div class="config-title">
						<span>
							里程
							<span class="config-subtitle">(万公里)</span>
						</span>
						<span
							class="reset-section"
							@click="selection.mileages = []"
							:class="{ active: !!selection.mileages.length }"
						>
							重置
						</span>
					</div>
					<ChartRanger type="mileage" :range.sync="selection.mileages[0]" />
				</div>

				<div class="filter-config" id="config-color">
					<div class="config-title">
						<span>
							外观颜色
						</span>
						<span
							class="reset-section"
							@click="selection.colors = []"
							:class="{ active: !!selection.colors.length }"
						>
							重置
						</span>
					</div>

					<div class="config-item-list">
						<div
							v-for="color in allCarColors"
							:key="color.value"
							class="config-item color-type"
							:class="{
								selected: selection.colors.some(val => val === color.value)
							}"
							@click="
								selection.colors.some(val => val === color.value)
									? (selection.colors = selection.colors.filter(val => val !== color.value))
									: selection.colors.push(color.value)
							"
						>
							<!-- <i class="color-tag" :style="{ background: color.hex }"></i> -->
							<img class="color-tag" :src="color.hex" />
							{{ color.value }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="submit-btn-row">
			<nio-button
				round
				@click="handleReset"
				type="btn_outline_l"
				v-sd-clk:FilterItemClick="{
					button_name: '重置',
					page: '二手车商城',
					page_source: pageSource,
					requirement_id: 2015,
					track_sign: 'aMall.b72.d73.click.FilterItemClick'
				}"
			>
				重置
			</nio-button>
			<nio-button
				round
				@click="handleSubmit"
				type="btn_solid_l"
				v-sd-clk:FilterItemClick="{
					...trackInfo,
					page: '二手车商城',
					page_source: pageSource,
					button_name: '查看',
					requirement_id: 2015,
					track_sign: 'aMall.b72.d2245.click.FilterItemClick'
				}"
			>
				{{ selectionCount > 0 ? `查看${selectionCount}台车` : '查看' }}
			</nio-button>
		</div>

		<AddressList v-model="pickedCityInfo" :show.sync="isShowAddressList" />
	</div>
</template>

<script>
import util from '@/util/util'
import {
	allCarColors,
	allCarTypes,
	getEmptyFilter,
	getTrackInfo,
	getVehicleQueryParams,
	modelImagePics,
	modelImgNames
} from '@/views1/IndexPage/filterOptions'
import { getOfficialCenter, queryVehicles } from '@/model'
import AddressList from '@/views1/OrderCreatorPage/AddressList'
import ChartRanger from '@/components/ChartRanger'
import { getSafeInsetBottom } from '@/util/unit-transfer'

const ConfigArrayOptions = [
	'sellers',
	'priceRanges',
	'ages',
	'mileages',
	'carTypes',
	'colors',
	'originCities',
	'battery'
]

export default {
	name: 'FilterPanel',
	components: { ChartRanger, AddressList },
	props: {
		config: {
			type: Object,
			required: true
		},
		visible: {
			type: Boolean,
			required: true
		}
	},
	data() {
		return {
			sections: [
				{ id: 'businessType', label: '类型' },
				{ id: 'originCity', label: '车源地' },
				{ id: 'carModel', label: '车型' },
				{ id: 'price', label: '价格' },
				{ id: 'age', label: '车龄' },
				{ id: 'color', label: '颜色' }
			],
			officialCenters: [],

			curSection: 'businessType',

			allCarTypes,
			modelImgNames: modelImgNames,
			modelImagePics: modelImagePics,
			allCarColors,

			allSeller: [
				{ value: 1, label: '官方二手车' },
				{ value: 2, label: '车主直售' },
				{ value: 4, label: '车商直售' }
			],
			allBaasTypes: [
				{ value: 1, label: '整车购买' },
				{ value: 2, label: '电池租用' }
			],
			allBatteries: [
				{ value: '0,3', label: '70/75kWh' },
				{ value: '2', label: '100kWh' },
				{ value: '8', label: '102kWh' }
			],

			selection: JSON.parse(JSON.stringify(this.config)),

			selectionCount: null,
			counterId: 0,
			isShowAddressList: false,
			pickedCityInfo: null,

			visibleConfigItems: new Set(),
			manualPicking: false,

			safeAreaInsetBottom: getSafeInsetBottom()
		}
	},
	computed: {
		onlyOfficial() {
			// return this.selection.sellers.length === 1 && this.selection.sellers[0] === 1

			// 车商直售 MVP：车源地无差别，都改成 -> 添加按钮
			return false
		},
		trackInfo() {
			return getTrackInfo(this.selection)
		},
		pageSource() {
			return this.$route.query.page_source;
		}
	},
	created() {
		this.fetchCount()
	},
	mounted() {
		this.initIntersectionObservers()
		this.$refs.filterContent.addEventListener('scroll', this.onContentScroll)

		this.fetchOfficialCenters()
	},
	beforeDestroy() {
		this.$refs.filterContent.removeEventListener('scroll', this.onContentScroll)
	},
	methods: {
		initIntersectionObservers() {
			if (window.IntersectionObserver) {
				this.sections.forEach(section => {
					const name = section.id

					new IntersectionObserver(
						([entry]) => {
							if (entry.isIntersecting) {
								this.visibleConfigItems.add(name)
							} else {
								this.visibleConfigItems.delete(name)
							}
						},
						{
							threshold: 0.5
						}
					).observe(document.getElementById('config-' + name))
				})
			}
		},
		onContentScroll() {
			if (this.visibleConfigItems.size > 0 && !this.manualPicking) {
				this.curSection = [...this.visibleConfigItems].pop()
			}
		},
		gotoSection(sectionId) {
			this.manualPicking = true
			this.curSection = sectionId

			document.getElementById('config-' + sectionId).scrollIntoView({ block: 'start' })

			setTimeout(() => {
				this.manualPicking = false
			}, 20)
		},
		handleReset() {
			this.selection = getEmptyFilter()
		},
		handleSubmit() {
			this.$emit('close')
			this.$emit('change', {
				...this.selection
			})
		},

		async fetchCount() {
			const params = getVehicleQueryParams(this.selection)

			const counterId = Date.now()
			this.counterId = counterId

			const { data } = await queryVehicles.post({
				...params
			})

			if (counterId !== this.counterId) {
				return
			}

			if (data.result_code !== 'success') {
				throw new Error()
			}

			this.selectionCount = data.data.total

			if (data.data.total === 0) {
				this.$toast('暂无符合条件的车辆，可为你推荐其他车辆')
			}
		},

		pickConfigItem(type, value) {
			let idx = this.selection[type].indexOf(value)
			if (idx >= 0) {
				this.selection[type].splice(idx, 1)
			} else {
				this.selection[type].push(value)
			}
		},
		async fetchOfficialCenters() {
			const res = await getOfficialCenter.post(
				{},
				{
					params: {
						area_code: '320500,420100,120100,350100,330100,510100,310100,370100,340100,610100'
					}
				}
			)

			// this.officialCenters =
			if (res.data && res.data.data.length) {
				this.officialCenters = res.data.data.map(item => ({
					code: item.area_code,
					name: item.name
				}))
			}
		}
	},
	watch: {
		selection: {
			deep: true,
			handler() {
				this.fetchCount()
			}
		},
		visible(visible) {
			if (visible) {
				this.selection = JSON.parse(JSON.stringify(this.config))
			}
		},
		onlyOfficial() {
			this.selection.originCities = []
		},

		pickedCityInfo(info) {
			if (!info || !info.city) {
				return
			}

			if (this.selection.originCities.some(one => one.code === info.city.area_code)) {
				return
			}

			this.selection.originCities.push({
				code: info.city.area_code,
				name: info.city.name
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';
.filter-panel {
	//position: absolute;
	width: 100%;
	//top: 48px;
	//bottom: 0;
	height: calc(var(--full-viewport-height) - 48px);
	background-color: #ffffff;
	z-index: 1100;

	display: flex;
	flex-direction: column;

	.panel-header {
		height: 57px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding: 0 20px;

		&:first-child {
			@include subtitle_3(1.1, 500, false);
		}
		.back-btn {
			width: 25px;
			height: 25px;
			color: $color_mb1_front;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

	.panel-config-list {
		flex: 1;
		overflow-y: hidden;
		display: flex;

		.vertical-indicator {
			width: 82px;
			height: 100%;
			background-color: $bg_secondary;

			.section-item {
				width: 100%;
				height: 66px;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 14px;
				color: $text_secondary;

				&.active {
					font-weight: 500;
					background-color: #ffffff;
					color: $text_primary;
				}
			}
		}

		.filter-content {
			flex: 1;
			padding: 15px 20px;
			box-sizing: border-box;
			height: 100%;
			overflow-y: auto;

			.filter-config {
				&:not(:last-child) {
					margin-bottom: 60px;
				}

				.config-title {
					margin-bottom: 20px;
					font-size: 14px;
					line-height: 25px;
					color: $text_primary;

					display: flex;
					justify-content: space-between;
					align-items: center;
					font-weight: 500;

					.reset-section {
						font-weight: 400;
						color: $text_disable;

						&.active {
							color: $text_secondary;
						}
					}
				}

				.config-subtitle {
					font-size: 12px;
					color: $text_tertiary;
					font-weight: 400;
				}

				.config-item-list {
					display: grid;
					grid-template-columns: 1fr 1fr;
					grid-gap: 15px;

					.config-item {
						position: relative;
						box-sizing: border-box;
						border: 1px solid #e9ecf1;
						color: $color_mb1_front;

						font-size: 14px;
						line-height: 25px;
						display: flex;
						justify-content: center;
						align-items: center;
						height: 45px;
						overflow: hidden;
						&.color-type {
							justify-content: flex-start;
							padding-left: 15px;

							//&.selected {
							//  padding-left: 47px;
							//}
						}

						&.selected {
							border-color: #040b29;
						}

						&.tag {
							justify-content: space-between;
							padding: 0 15px;

							> :first-child {
								overflow-x: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								flex: 1;
							}
						}

						&.large {
							position: relative;
							height: 86px;

							div {
								position: absolute;
								top: 10px;
								left: 15px;
							}
							.model-pic {
								position: absolute;
								bottom: 5px;
								right: 4px;
								height: 48px;
							}

							.model-name {
								position: absolute;
								top: 10px;
								left: 15px;
								height: 15px;
							}
						}
						.color-tag {
							display: inline-block;
							width: 24px;
							height: 24px;
							border-radius: 12px;
							margin-right: 10px;
						}
					}
				}
			}
		}
	}

	&.hair {
		.submit-btn-row {
			padding-bottom: 35px;
		}
	}
	.submit-btn-row {
		padding: 15px 20px 15px;
		color: #ffffff;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;

		> :first-child {
			width: 116px;
			margin-right: 10px;
		}

		> :last-child {
			flex: 1;
		}
	}
}
</style>

<style lang="scss">
.nio-toast {
	z-index: 10086;
}

.nio-button.btn_outline_l[data-v-6f4765ef]:not([disabled]):hover {
	background-color: unset;
}
</style>
